import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@shared/components/confirmDialog/ConfirmDialog';
import { formatTimeWithUnits } from '@shared/utils/FormatTime';

interface EditCampaignDialogsProps {
  showScheduleWarningDialogFlag: boolean;
  onCloseScheduleDialog: () => void;
  setShowScheduleWarningDialogFlag: React.Dispatch<React.SetStateAction<boolean>>;
  timeUntilStartCampaignRun: number;
  onRunCampaign: () => void | Promise<void>;
  showUsageLimitWarningDialog: boolean;
  setShowUsageLimitWarningDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onUsageLimitWarningConfirm: () => void | Promise<void>;
  showUsageLimitBlockedDialog: boolean;
  setShowUsageLimitBlockedDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EditCampaignDialogs: React.FC<EditCampaignDialogsProps> = ({
  showScheduleWarningDialogFlag,
  onCloseScheduleDialog,
  setShowScheduleWarningDialogFlag,
  timeUntilStartCampaignRun,
  onRunCampaign,
  showUsageLimitWarningDialog,
  setShowUsageLimitWarningDialog,
  onUsageLimitWarningConfirm,
  showUsageLimitBlockedDialog,
  setShowUsageLimitBlockedDialog,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ConfirmDialog
        showDialogFlag={showScheduleWarningDialogFlag}
        handleClose={onCloseScheduleDialog}
        dialogTitle={'dialog.title4'}
        dialogContentText={t('dialog.content4', {
          timeToStart: formatTimeWithUnits(timeUntilStartCampaignRun),
        })}
        variant="warning"
        showDialog={setShowScheduleWarningDialogFlag}
        confirmDialog={onRunCampaign}
      />
      <ConfirmDialog
        showDialogFlag={showUsageLimitWarningDialog}
        handleClose={() => setShowUsageLimitWarningDialog(false)}
        dialogTitle={'dialog.usageLimitWarningTitle'}
        dialogContentText={t('dialog.usageLimitWarningContent')}
        showDialog={setShowUsageLimitWarningDialog}
        confirmDialog={onUsageLimitWarningConfirm}
      />
      <Dialog
        open={showUsageLimitBlockedDialog}
        onClose={() => setShowUsageLimitBlockedDialog(false)}
        aria-labelledby="usage-limit-blocked-title"
        aria-describedby="usage-limit-blocked-description">
        <DialogTitle id="usage-limit-blocked-title">
          {t('dialog.usageLimitBlockedTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="usage-limit-blocked-description">
            {t('dialog.usageLimitBlockedContent')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowUsageLimitBlockedDialog(false)}>
            {t('adminMainPage.operation.ok')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
